<template>
    <div>
        <div class="container is-max-desktop p-5">
            <LoginHeader/>
            <div class="columns">
                <div class="column">
                    <div class="content">
                    <img :src="resetPasswordUrl">
                    </div>
                </div>
                <div class="column" v-if="setNewPasswordSuccess">
                    <div class="card">
                        <p class="card-header-title pl-5">
                            {{$t('reset_password_success_title')}}
                        </p>
                        <div class="card-content has-text-left">
                            <p class="mb-5">{{$t('reset_password_success_info_text')}}</p>
                            <div class="columns">
                                <div class="column is-flex is-align-items-center">
                                    <router-link to="login" custom v-slot="{navigate}">
                                        <a @click="navigate" role="link"><b-icon size="is-small" icon="arrow-left"></b-icon> {{$t('login')}}</a>
                                    </router-link>
                                </div>
                            </div>  
                        </div>
                    </div>
                </div>
                <div v-else class="column">
                    <div class="card">
                    <p class="card-header-title pl-5">
                        {{$t('set_new_password')}}
                    </p>
                    <ValidationObserver ref="observer" v-slot="{ handleSubmit }">
                    <div class="card-content has-text-left">
                        <p class="mb-5">{{$t('set_new_password_info_text')}}</p>
                        <ValidationProvider :rules="passwordRules" v-slot="{ errors }" :bails="false" vid="form.password">
                        <b-field :label="labels.password.show?$t('password'):''" :label-position="labels.password.position" class="mb-5"
                        :type="{'is-danger':errors[0]}"
                        :message="translateErrors(errors)">
                            <b-input type="password" password-reveal :placeholder="$t('password')+'*'" @keyup.enter.native="handleSubmit(resetPasswordF)" v-model.trim="form.password" @focus="focusInput('password')" @blur="blurInput('password')"></b-input>                  
                        </b-field>
                        </ValidationProvider>
                        <ValidationProvider rules="requiredRePassword|confirmedPassword:form.password" v-slot="{ errors }">
                        <b-field :label="labels.rePassword.show?$t('rePassword'):''" :label-position="labels.rePassword.position" class="mb-5"
                        :type="{'is-danger':errors[0]}"
                        :message="[$t(errors[0])]">
                            <b-input type="password" password-reveal :placeholder="$t('rePassword')+'*'" @keyup.enter.native="handleSubmit(resetPasswordF)" v-model.trim="form.rePassword" @focus="focusInput('rePassword')" @blur="blurInput('rePassword')"></b-input>                  
                        </b-field>
                        </ValidationProvider>
                        <div class="columns">
                        <div class="column is-flex is-align-items-center is-justify-content-space-between">
                            <b-button type="is-primary" @click="handleSubmit(resetPasswordF)">{{$t('reset_password')}}</b-button>
                        </div>
                        </div>  
                    </div>
                    </ValidationObserver>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import {mapActions} from 'vuex'
import { ValidationProvider, ValidationObserver, extend } from 'vee-validate';
import { confirmed, required, regex } from 'vee-validate/dist/rules';
import LoginHeader from './LoginHeader';

extend('confirmedPassword', {
  ...confirmed,
  message: 'password_is_not_confirmed'
});

extend('confirmed', {
  ...confirmed,
  message: 'password_is_not_confirmed'
});

extend('requiredPassword', {
  ...required,
  message: 'password_is_required'
});

extend('requiredRePassword', {
  ...required,
  message: 'rePassword_is_required'
});

extend('hasUppercase', {
  ...regex,
  message: 'password_rule_uppercase'
});

extend('hasLowercase', {
  ...regex,
  message: 'password_rule_lowercase'
});

extend('checkLength', {
  ...regex,
  message: 'password_rule_length'
});

extend('hasDigit', {
  ...regex,
  message: 'password_rule_digit'
});

extend('hasSpecialChar', {
  ...regex,
  message: 'password_rule_special_char'
});


export default {
    name:"ResetPassword",
    components: {
        LoginHeader,
        ValidationObserver,
        ValidationProvider
    },
    data() {
        return {
            resetPasswordUrl:"/static/images/ResetPassword.svg",
            form:{
                password:'',
                rePassword:'',
                resetCode:''
            },
            value:'',
            confirmation:'',
            labels:{
                password:{position:'',show:false},
                rePassword:{position:'',show:false}
            },
            setNewPasswordSuccess:false,
            passwordRules:{
                hasUppercase:{ "regex": /[A-Z]+/ },
                hasLowercase:{ "regex": /[a-z]+/ },
                checkLength: { "regex": /.{8,32}/},
                hasDigit: { "regex": /[0-9]+/},
                hasSpecialChar: { "regex": /[#?!@$%^&-]+/},
                requiredPassword : true
            }
            
        }
    },
    methods: {
        ...mapActions(['resetPassword']),
        focusInput(val){
            this.labels[val].position='on-border'
            this.labels[val].show=true
        },
        blurInput(val){
            if(this.form[val]==''){
                this.labels[val].show=false
            }
        },
        translateErrors(arr){
            return arr.map(e => this.$t(e));
        },
        resetPasswordF(){
            this.resetPassword(this.form).then((response) => {
                console.log('--requestPasswordReset success response')
                console.log(response)
                if(response.status.code=='0'){
                    this.setNewPasswordSuccess=true
                }
            }).catch(e => {
                console.log("--requestPasswordReset Error")
                console.log(e)
            })
        }
    },
    mounted(){
        if(this.$route.query.resetCode){
            this.form.resetCode = this.$route.query.resetCode
        }
    },
    created(){
        
    }
}
</script>


// WEBPACK FOOTER //
// src/components/ResetPassword.vue